/**
 * 前端加解密工具
 * 使用 AES-256-CBC 加密
 */

import CryptoJS from 'crypto-js';

// 密钥和 IV（前端使用 NEXT_PUBLIC_ 前缀）
const ENCRYPT_KEY = process.env.NEXT_PUBLIC_ENCRYPT_KEY || '';
const ENCRYPT_IV = process.env.NEXT_PUBLIC_ENCRYPT_IV || '';

/**
 * 加密数据
 */
export function encrypt(data: unknown): string {
  if (!ENCRYPT_KEY || !ENCRYPT_IV) {
    console.warn('Encryption key not configured, returning plain data');
    return JSON.stringify(data);
  }

  const key = CryptoJS.enc.Hex.parse(ENCRYPT_KEY);
  const iv = CryptoJS.enc.Hex.parse(ENCRYPT_IV);

  const jsonStr = JSON.stringify(data);
  const encrypted = CryptoJS.AES.encrypt(jsonStr, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
}

/**
 * 解密数据
 */
export function decrypt<T = unknown>(encryptedData: string): T {
  if (!ENCRYPT_KEY || !ENCRYPT_IV) {
    console.warn('Encryption key not configured, parsing as JSON');
    return JSON.parse(encryptedData) as T;
  }

  try {
    const key = CryptoJS.enc.Hex.parse(ENCRYPT_KEY);
    const iv = CryptoJS.enc.Hex.parse(ENCRYPT_IV);

    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const jsonStr = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(jsonStr) as T;
  } catch (error) {
    // 如果解密失败，尝试直接解析（兼容模式）
    console.warn('Decrypt failed, trying to parse as JSON');
    return JSON.parse(encryptedData) as T;
  }
}

/**
 * 检查是否启用加密
 */
export function isEncryptionEnabled(): boolean {
  return !!(ENCRYPT_KEY && ENCRYPT_IV && ENCRYPT_KEY.length === 64 && ENCRYPT_IV.length === 32);
}
